
@if (universalService.showContextMenu == true) {
  <ul id="customContextMenu" class="customContextMenu"
    >
    @for (item of universalService.contextMenuOptions; track item) {
      <li id="{{item.onClick}}">
        <div class="Option contextMenuItemDiv" (click)="decideAction(item.onClick, $event)"  [ngClass]="item.title == 'Share link' && this.universalService.isAllowPublicShare == false || item.title == 'Add to Album' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
          <span class="{{item.iconName}}"></span> {{item.menuItem}} <span class="{{item.moreOptionsIcon}} moreOptionsIcon"></span>
        </div>
      </li>
    }
  </ul>
}

@if (this.universalService.selectedNodes.length > 0 && this.universalService.showContextMenu == true) {
  <ul id="customContextMenu" class="customContextMenu moreOptionsCustomContextMenu"
    >
    @for (item of universalService.contextMenuMoreOptions; track item) {
      <li>
        <div class="Option contextMenuItemDiv contextMenuMoreOptionsItemDiv" (click)="decideAction(item.onClick, $event)">
          @if (item.iconName != '') {
            <span class="{{item.iconName}}"></span>
            } @if (item.imageUrl && item.iconName == '') {
            <img class="img-fluid" src="{{item.imageUrl}}">
            } {{item.menuItem}}
          </div>
        </li>
      }
    </ul>
  }

